// PartA4FutureSelf.js
import React from 'react';
import { Input, Slider, Row, Col } from 'antd';

const { TextArea } = Input;

const PartA4FutureSelf = ({ formData, handleInputChange }) => {

    // Custom slider component to match the look
    const CustomSlider = ({ value, onChange, label, leftLabel, rightLabel }) => (
        <div className="mb-8">
            <div className="flex justify-between mb-2">
                <span className="font-bold text-base">{label}</span>
            </div>
            <div className="flex items-center gap-4">
                <span className="font-bold text-red-500 text-xl">-</span>
                <div className="flex-1 relative h-2 rounded-full overflow-hidden">
                    {/* Gradient Background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-red-500 via-yellow-400 to-green-500"></div>
                    {/* Slider Thumb (using Ant Design Slider on top with transparent track) */}
                    <Slider
                        value={value || 0}
                        onChange={onChange}
                        min={0}
                        max={100}
                        tooltip={{ open: false }}
                        trackStyle={{ backgroundColor: 'transparent' }}
                        railStyle={{ backgroundColor: 'transparent' }}
                        handleStyle={{
                            borderColor: '#fff',
                            backgroundColor: '#000',
                            opacity: 1,
                            width: 16,
                            height: 16,
                            marginTop: -7,
                            boxShadow: '0 0 0 2px rgba(0,0,0,0.1)'
                        }}
                        className="m-0 p-0 absolute inset-0 z-10"
                    />
                </div>
                <span className="font-bold text-green-500 text-xl">+</span>
            </div>
        </div>
    );

    return (
        <div className="a4-page font-[poppins] bg-white p-8 mx-auto text-[#333333]" style={{ maxWidth: '100%', width: '100%' }}>

            {/* Header */}
            <div className="bg-[#BFDBFE] p-3 font-bold text-lg text-black flex items-center justify-center mb-6 rounded-t-lg">
                <span className="mr-2 text-2xl">📅</span>
                Let’s imagine your ‘Future Self’, 10 years from now...
            </div>

            {/* Future Self Table */}
            <div className="grid grid-cols-3 border border-blue-300 rounded-lg overflow-hidden mb-8">
                {/* Headers */}
                <div className="bg-[#DBEAFE] p-3 text-center border-r border-blue-300 flex items-center justify-center">
                    <span className="font-bold text-sm">
                        What will you be doing to <span className="text-[#F97316]">improve</span> yourself?
                    </span>
                </div>
                <div className="bg-[#DBEAFE] p-3 text-center border-r border-blue-300 flex items-center justify-center">
                    <span className="font-bold text-sm">
                        What will you be doing to <span className="text-[#F97316]">support</span> your friends and family?
                    </span>
                </div>
                <div className="bg-[#DBEAFE] p-3 text-center flex items-center justify-center">
                    <span className="font-bold text-sm">
                        What will you be doing to <span className="text-[#F97316]">improve</span> society?
                    </span>
                </div>

                {/* Inputs */}
                <div className="bg-[#EFF6FF] border-r border-blue-300">
                    <TextArea
                        className="bg-transparent border-none resize-none h-64 p-4 focus:shadow-none text-center"
                        value={formData.future_improve_self}
                        onChange={(e) => handleInputChange('future_improve_self', e.target.value)}
                    />
                </div>
                <div className="bg-[#EFF6FF] border-r border-blue-300">
                    <TextArea
                        className="bg-transparent border-none resize-none h-64 p-4 focus:shadow-none text-center"
                        value={formData.future_support_family}
                        onChange={(e) => handleInputChange('future_support_family', e.target.value)}
                    />
                </div>
                <div className="bg-[#EFF6FF]">
                    <TextArea
                        className="bg-transparent border-none resize-none h-64 p-4 focus:shadow-none text-center"
                        value={formData.future_improve_society}
                        onChange={(e) => handleInputChange('future_improve_society', e.target.value)}
                    />
                </div>
            </div>

            {/* Feelings Section */}
            <div className="mb-8">
                <div className="bg-[#BFDBFE] p-2 font-bold text-center text-black mb-6">
                    How do I feel about my future?
                </div>

                <p className="font-bold mb-4">Circle as applicable.</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                    <CustomSlider
                        label="Prepared"
                        value={formData.feeling_prepared}
                        onChange={(val) => handleInputChange('feeling_prepared', val)}
                    />
                    <CustomSlider
                        label="Excited"
                        value={formData.feeling_excited}
                        onChange={(val) => handleInputChange('feeling_excited', val)}
                    />
                    <CustomSlider
                        label="Confident"
                        value={formData.feeling_confident}
                        onChange={(val) => handleInputChange('feeling_confident', val)}
                    />
                    <CustomSlider
                        label="Curious"
                        value={formData.feeling_curious}
                        onChange={(val) => handleInputChange('feeling_curious', val)}
                    />
                </div>
            </div>

            {/* Reflection Boxes */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="border border-blue-400 rounded-lg overflow-hidden flex flex-col h-64">
                    <div className="bg-[#3B82F6] text-white font-bold text-center py-2 mx-12 mt-4 rounded shadow-md">
                        Why do you think so?
                    </div>
                    <TextArea
                        className="flex-1 border-none resize-none p-4 focus:shadow-none"
                        value={formData.future_why_think_so}
                        onChange={(e) => handleInputChange('future_why_think_so', e.target.value)}
                    />
                </div>
                <div className="border border-blue-400 rounded-lg overflow-hidden flex flex-col h-64">
                    <div className="bg-[#3B82F6] text-white font-bold text-center py-2 mx-12 mt-4 rounded shadow-md">
                        Parents’ feedback
                    </div>
                    <TextArea
                        className="flex-1 border-none resize-none p-4 focus:shadow-none"
                        value={formData.future_parents_feedback}
                        onChange={(e) => handleInputChange('future_parents_feedback', e.target.value)}
                    />
                </div>
            </div>

        </div>
    );
};

export default PartA4FutureSelf;